import { writable } from 'svelte/store';
export class NewListItemsStore {
    constructor(itemsStore, filter = _ => true) {
        this.store = writable([]);
        this.lastItems = [];
        this.subscribe = this.store.subscribe;
        itemsStore.subscribe(_items => {
            _items = _items.filter(filter);
            if (this.lastItems.length < _items.length) {
                this.store.set(_items.slice(this.lastItems.length));
            }
            this.lastItems = _items;
        });
    }
}
